import {
  DOC_FLOW_UPLOADING_ACTION_DELETE,
  DOC_FLOW_UPLOADING_MASS_ACTION_CHANGE_TYPE,
  DOC_FLOW_UPLOADING_MASS_ACTION_DELETE,
} from '../../DocFlow.constants'

export function isChangeTypeMassAction(action) {
  return action !== DOC_FLOW_UPLOADING_MASS_ACTION_CHANGE_TYPE
}

export function isDeleteMassAction(action) {
  return action === DOC_FLOW_UPLOADING_MASS_ACTION_DELETE
}

export function isDeleteAction(action) {
  return action === DOC_FLOW_UPLOADING_ACTION_DELETE
}
